import React, { useEffect, useState } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import Spinner from 'react-spinkit';
import { GetDocument } from '../../../../firebase/firebase';

export const RecipePage = (props) => {
    const id = props.id
    const [recipe, setRecipe] = useState('')
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (loading) {

            GetDocument("recipes", id).then((data) => {
                setRecipe(data.data())

            })
            setLoading(false)
        }

    }, [loading])

    if (recipe.type == 'newFormat') {
        return (
            <>
            
                <RecipePreview recipe={recipe} />
            </>
        )
    }
    else {
        return (
            <>

                {loading ?
                    <Container style={{ top: '0', position: 'absolute' }} fluid className='min-vh-100 d-flex flex-grow-1'>
                        <Row className="justify-content-center flex-grow-1">
                            <Col className='d-flex justify-content-center align-items-center'>
                                <Spinner className="d-flex flex-wrap align-items-center mx-0 px-0" name='ball-pulse-sync' />
                            </Col>
                        </Row>
                    </Container>
                    :
                    <Container fluid className='pt-4'>
                        <Row className="justify-content-center">
                            <Col lg={6}>
                                <Card>
                                    <Card.Header>
                                        {recipe.title}
                                    </Card.Header>
                                    <Row>

                                    </Row>

                                    <Card.Body>
                                        {recipe.description}
                                    </Card.Body>

                                </Card>
                            </Col>
                        </Row>
                    </Container>
                }
            </>
        )
    }
}

const RecipePreview = (props) => {
    const recipe = props.recipe
    return (
        <>
            <Card>
                <Card.Body>
                    <Card.Header>
                        <h4 className='text-center mx-auto d-block'>{recipe.title}</h4>
                    </Card.Header>
                    <Row>
                        <Col md={6} className='text-center mx-auto d-block'>
                            {recipe.image &&
                                <Card.Img
                                    variant='top'
                                    src={recipe.image}
                                    className='p-3'
                                    style={{ height: '300px', width: 'auto' }}
                                />

                            }
                        </Col>

                    </Row>

                    <Row>
                        <Col md={6} className='p-3'>
                            <Card>
                                <Card.Body>
                                    <Card.Header>
                                        <h4 className='text-center mx-auto d-block'>Ingredients</h4>
                                    </Card.Header>
                                    {recipe.ingredients && recipe.ingredients.map((ingredient, idx) => (
                                        <Row key={`previewIngredients-${idx}`}>
                                            - {ingredient}
                                        </Row>
                                    ))}
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6} className='p-3'>
                            <Card>
                                <Card.Body>
                                    <Card.Header>
                                        <h4 className='text-center mx-auto d-block'>Directions</h4>
                                    </Card.Header>
                                    {recipe.directions && recipe.directions.map((direction, idx) => (
                                        <Row key={`previewDirections-${idx}`}>
                                            {idx + 1}: {direction}
                                        </Row>
                                    ))}
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                    
                </Card.Body>
            </Card>
        </>
    )
}